<script>
  import { dark_theme } from '../../stores'
  import Insert_Teaser from './templates/Teaser.svelte'
  import Insert_Upgrade from './templates/Upgrade.svelte'

  export let insert_position
  export let inbetween_counter

</script>

<!-- Before Preview -->
{#if insert_position === 'before_previews'}
  {#if !$dark_theme}
    <Insert_Teaser feature="theme"/>
  {/if}
{/if}

<!-- Between Previews -->
{#if insert_position === 'between_previews'}
  {#if inbetween_counter === 4}
    <Insert_Upgrade feature="theme"/>
  {/if}
{/if}